export const shortMonthNames = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin", "Juil", "Aou", "Sep", "Oct", "Nov", "Dec"];



// WEBPACK FOOTER //
// ./src/constants/month.js